import { Injectable, NgModule, inject } from '@angular/core';
import {api} from '../../../api/api-dictionnary';
import {HydraService} from '../../../core/services/hydra.service';
import {HydraCollection} from '../../../class/generic/hydra-collection';

@NgModule({
    providers: [HydraService],
})
@Injectable()
export class FieldTypesService {
    private hydraService = inject(HydraService);

    public listeFieldTypes = [];
    public listeFieldTypesBasic = [];
    public listeFieldTypesDossier = [];
    public listeFieldTypesExpert = [];
    public listeFieldEquipeAssociee = [];
    public listeFieldRapportScientifique = [];


    /****************************************************************************************************************
     * Creates an instance of FieldTypesService.
     * @param {HydraService} hydraService
     * @memberof FieldTypesService
     */
    constructor() {
        this.getFieldsType();
    }

    /****************************************************************************************************************
     *
     * @description Recuperer liste de tous les champs possibles
     * @memberof FieldTypesService
     */
    public getFieldsType() {
        return this.hydraService.getList(api.fieldType, true).subscribe(res => {
            const data = new HydraCollection(res);
            this.listeFieldTypes = data.getMember();
            this.listeFieldTypes.map(item => {
                // NOTE : Field precision supprimer de l'interface AB car non nécessaire pour le client
                if (
                    item['group'] == 'basic' &&
                    item['@id'].indexOf('choiceUniquePrecision') == -1
                ) {
                    this.listeFieldTypesBasic.push(item);
                }
                if (item['group'] == 'specialExpert') {
                    this.listeFieldTypesExpert.push(item);
                }
                if(item['group'] == 'hybride') {
                    this.listeFieldTypesDossier.push(item);
                    this.listeFieldEquipeAssociee.push(item);
                    this.listeFieldRapportScientifique.push(item);
                }
                if (item['group'] == 'equipeAssociee') {
                    this.listeFieldTypesDossier.push(item);
                }
                if (item['group'] == 'dossier') {
                    this.listeFieldEquipeAssociee.push(item);
                    this.listeFieldTypesDossier.push(item);
                }
                if (item['group'] == 'RapportScientifique') {
                    this.listeFieldRapportScientifique.push(item);
                }
            });
            this.listeFieldTypesBasic.sort(this.trieParLabel);
            this.listeFieldTypesDossier.sort(this.trieParLabel);
            this.listeFieldTypesExpert.sort(this.trieParLabel);
            this.listeFieldEquipeAssociee.sort(this.trieParLabel);
            this.listeFieldRapportScientifique.sort(this.trieParLabel);
        });
    }

    private trieParLabel(a, b) {
        if (a.label < b.label) {return -1;}
        if (a.label > b.label) {return 1;}
        return 0;
    }
}
